import type { NotificationsResponse } from '@/types'
import { request, buildQueryString } from './client'

export async function getNotifications(limit: number = 50): Promise<NotificationsResponse> {
  const query = buildQueryString({ limit })
  return request(`/notifications${query}`)
}

export async function getUnreadCount(): Promise<{ unreadCount: number }> {
  return request('/notifications/unread_count')
}

export async function markNotificationRead(id: number, idempotencyKey?: string): Promise<void> {
  await request<void>(`/notifications/${id}/read`, { method: 'PATCH', idempotencyKey })
}

export async function markAllNotificationsRead(idempotencyKey?: string): Promise<void> {
  await request<void>('/notifications/mark_all_read', { method: 'POST', idempotencyKey })
}

export async function deleteNotification(id: number, idempotencyKey?: string): Promise<void> {
  await request<void>(`/notifications/${id}`, { method: 'DELETE', idempotencyKey })
}
